import { Modal } from "flowbite-react"
import { UserContext } from "./contexts"
import { useContext, useState } from "react"
import * as Iconoir from "iconoir-react"
import { settings } from "@/settings"

interface GiftSubscriptionModalProps {
  show: boolean
  onClose: () => void
}

const GiftSubscriptionModal = ({ show, onClose }: GiftSubscriptionModalProps) => {
  const user = useContext(UserContext)
  const [copied, setCopied] = useState(false)
  const giftLink = `${settings.VIBRATO_FRONTEND_URL}/gift?uuid=${user.uuid}`

  const handleCopy = () => {
    navigator.clipboard.writeText(giftLink)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <Modal show={show} onClose={onClose} popup size="lg" className="pt-safe">
      <div className="relative p-6 text-center bg-gradient-to-br from-indigo-600 to-purple-700 rounded-lg">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-1 rounded-full text-indigo-200 hover:text-white hover:bg-white/10 transition-colors"
          aria-label="Close"
        >
          <Iconoir.Xmark />
        </button>

        <div className="mb-4">
          <div className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center">
            <Iconoir.Crown className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-white mb-2">Gift Vibrato Plus</h2>
          <p className="text-lg text-indigo-200 mb-6">
            Be the hero! Give your friend a golden ticket to experience the full power of Vibrato with a free 30-day
            Plus trial.
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-6">
          <h3 className="text-white font-semibold mb-3 flex items-center justify-center gap-2">
            <Iconoir.Gift className="w-5 h-5" />
            What your friend gets:
          </h3>
          <div className="space-y-2 text-indigo-100 text-sm">
            <div className="flex items-center justify-center gap-2">
              <Iconoir.CheckCircle className="w-4 h-4 text-green-300" />
              <span>30 days of Vibrato Plus absolutely free</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <Iconoir.CheckCircle className="w-4 h-4 text-green-300" />
              <span>Unlimited daily calls</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <Iconoir.CheckCircle className="w-4 h-4 text-green-300" />
              <span>Voice cloning capability</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <Iconoir.CheckCircle className="w-4 h-4 text-green-300" />
              <span>Custom phone number</span>
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-2 bg-white p-2 rounded-lg mb-4">
          <input
            type="text"
            value={giftLink}
            readOnly
            className="w-full p-2 border-none rounded-lg bg-gray-100 text-gray-700 text-sm"
          />
          <button
            onClick={handleCopy}
            className={`p-3 rounded-lg transition-colors flex-shrink-0 ${
              copied ? "bg-green-500 text-white" : "bg-indigo-600 text-white hover:bg-indigo-700"
            }`}
          >
            {copied ? <Iconoir.Check /> : <Iconoir.Copy />}
          </button>
        </div>

        {copied && (
          <p className="text-white text-sm mb-4 flex items-center justify-center gap-2">
            <Iconoir.CheckCircle className="w-4 h-4" />
            Copied to clipboard!
          </p>
        )}

        <p className="text-indigo-200 text-xs">
          Share this link with friends who would love to experience premium AI calling for free.
        </p>
      </div>
    </Modal>
  )
}

export default GiftSubscriptionModal
